// uncomment the line below if you want to activate why-did-you-render
// import './wdyr';
import 'core-js';
import 'regenerator-runtime/runtime';
// @ts-expect-error [TS migration] Was not detected by flow
import amplitude from 'amplitude-js';

import * as React from 'react';

import store from 'store/store';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { LicenseManager } from 'ag-grid-enterprise';
import 'styles/main.scss';
import './i18n';
import { router } from 'store/router';
import { RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import {
    AG_GRID_KEY,
    AMPLITUDE_KEY,
    FLAVOUR,
    IS_PRESENTATION,
    IS_PREPROD,
    IS_PROD,
    IS_STAGING,
    SENTRY_DSN,
    VERSION,
} from 'env';

LicenseManager.setLicenseKey(AG_GRID_KEY);

// Setup Sentry for exception monitoring, Hotjar etc
if (IS_STAGING || IS_PROD || IS_PRESENTATION || IS_PREPROD) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: IS_PROD ? 'production' : 'staging',
        release: VERSION,
    });
    Sentry.setTag('flavour', FLAVOUR);

    amplitude.getInstance().init(AMPLITUDE_KEY);
}

const MOUNT_NODE = document.getElementById('root');
if (!MOUNT_NODE) {
    throw new Error('Root element not found');
}

createRoot(MOUNT_NODE).render(
    <StrictMode>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </StrictMode>,
);
